import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { MOQ } from "../lib/constants";

const CartContext = createContext(null);
const key = (uid) => `bt_cart_${uid || "guest"}`;

export const CartProvider = ({ children }) => {
    const { user } = useAuth();
    const [items, setItems] = useState([]);

    useEffect(() => {
        const raw = localStorage.getItem(key(user?.id));
        setItems(raw ? JSON.parse(raw) : []);
    }, [user?.id]);

    const save = (next) => {
        setItems(next);
        localStorage.setItem(key(user?.id), JSON.stringify(next));
    };

    const add = (product, qty = MOQ) => {
        const existing = items.find((i) => i.product_id === product.id);
        let next;
        if (existing) {
            next = items.map((i) =>
                i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i
            );
        } else {
            next = [
                ...items,
                {
                    product_id: product.id,
                    title: product.title,
                    brand: product.brand,
                    price: product.price,
                    currency: product.currency || "GBP",
                    quantity: qty,
                    image_url: product.image_url || "",
                    image_storage_path: product.image_storage_path || "",
                },
            ];
        }
        save(next);
    };

    const remove = (pid) => save(items.filter((i) => i.product_id !== pid));
    const setQty = (pid, qty) => {
        if (qty <= 0) return remove(pid);
        save(items.map((i) => (i.product_id === pid ? { ...i, quantity: qty } : i)));
    };
    const clear = () => save([]);

    const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const belowMoq = items.some((i) => i.quantity < MOQ);

    return (
        <CartContext.Provider value={{ items, add, remove, setQty, clear, total, count, belowMoq }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
